export default "__VITE_ASSET__DnHh2AAy__"